//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.component('toggleSwitch', {
    bindings: {
      toggleName: '@',
      toggleDisabled: '<',
      toggleIsActive: '<',
      toggledCallback: '&',
      tt: '@?',
    },
    template: require('@partials/toggle-switch.html'),
    controller: [
      function() {
        const self = this;

        this.toggleState = function() {
          self.toggledCallback({ state: !self.toggleIsActive });
        };
      },
    ],
  });
})();
